import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    dark: false, // Will be controlled by Vuex state
    themes: {
      light: {
        primary: '#1967a9',
        secondary: '#9C27b0',
        accent: '#9C27b0',
        info: '#00CAE3',
        success: '#4CAF50',
        warning: '#FB8C00',
        error: '#FF5252',
        background: '#FFFFFF',
        surface: '#FFFFFF',
      },
      dark: {
        primary: '#1967a9',
        secondary: '#9C27b0',
        accent: '#9C27b0',
        info: '#00CAE3',
        success: '#4CAF50',
        warning: '#FB8C00',
        error: '#FF5252',
        background: '#1e1e1e',  // Softer dark gray instead of pure black
        surface: '#2d2d2d',     // Slightly lighter surface for contrast
      },
    },
  },
})
